import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { utilNumber } from "../../../utils/utilNumber";
import { Icon } from "../../generic/icon/Icon";
import { IdIcon } from "../../generic/icon/IdIcon";
import { ProfilePicture } from "../../player-profile/ProfilePicture";
import { IdCoopCategory } from "../IdCoopCategory";
export var CoopMemberTableRow = function (_a) {
    var tab = _a.tab, member = _a.member, memberActivityClassName = _a.memberActivityClassName, memberRoleIcon = _a.memberRoleIcon, profilePicName = _a.profilePicName, onClick = _a.onClick;
    var name = member.name, xp = member.xp, donation = member.donation;
    return (React.createElement("div", { className: IdStyles.TableRowRankingBig + " tr mouse-hover " + IdStyles.TextNormal, onClick: onClick },
        tab === IdCoopCategory.CoopInfoView && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "td" },
                React.createElement("div", { className: "info-view-member-activity " + memberActivityClassName },
                    React.createElement(Icon, { icon: IdIcon.PlayerActivityIcn, styleId: "member-activity-background " + IdStyles.IconSmall }))),
            React.createElement("div", { className: "td__divider" }))),
        React.createElement("div", { className: "td" },
            React.createElement(Icon, { icon: memberRoleIcon, styleId: IdStyles.IconSmall })),
        React.createElement("div", { className: "td__divider" }),
        React.createElement("div", { className: "td td--pp" },
            React.createElement(ProfilePicture, { profilePictureName: profilePicName, profilePictureClassName: "ranking-profile-pic", profilePictureSize: IdStyles.ProfilePictureX_small }),
            name),
        React.createElement("div", { className: "td__divider" }),
        React.createElement("div", { className: "td" }, utilNumber.format(xp)),
        React.createElement("div", { className: "td__divider" }),
        React.createElement("div", { className: "td" }, utilNumber.format(donation))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/info-view/CoopMemberTableRow.tsx
// module id = 2613
// module chunks = 3